'use client';

import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { useTranslations } from 'next-intl';
import { FC, useEffect, useState } from 'react';

import {
  linkItem,
  linkItemAnchor,
  linkItems,
  title,
  wrapper,
} from './index.css';

/**
 * Props for `Summary`.
 */
export type SummaryProps = SliceComponentProps<Content.SummarySlice>;

/**
 * Component for "Summary" Slices.
 */
const Summary: FC<SummaryProps> = ({ slice }) => {
  const [titles, setTitles] = useState<HTMLHeadingElement[]>([]);
  const t = useTranslations();

  useEffect(() => {
    if (document) {
      setTitles(
        Array.from(document.querySelectorAll('h2')).filter((elem) =>
          elem.checkVisibility(),
        ),
      );
    }
  }, []);

  if (titles.length === 0) {
    return null;
  }

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={wrapper}
    >
      <span className={title}>{t('pages.guides.summary.title')}</span>
      <ul className={linkItems}>
        {titles.map((title) => (
          <li className={linkItem} key={title.id}>
            <a className={linkItemAnchor} href={`#${title.id}`}>
              {title.innerText}
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default Summary;
